/**
 * Current-team context — a CLIENT-ONLY concept. The backend has no notion of an
 * "active team"; every team-scoped call carries an explicit team_id. This store
 * holds which team the user is currently working in.
 *
 * Persisted in sessionStorage so it survives a reload within the tab, and cleared
 * on logout (see auth store clearAuth).
 */
import { defineStore } from "pinia";

const STORAGE_KEY = "zenith_current_team";

export const useTeamStore = defineStore("team", {
  state: () => ({
    currentTeamId: (sessionStorage.getItem(STORAGE_KEY) || null) as string | null,
  }),

  getters: {
    hasTeam: (state): boolean => !!state.currentTeamId,
  },

  actions: {
    setCurrent(id: string) {
      this.currentTeamId = id;
      sessionStorage.setItem(STORAGE_KEY, id);
    },

    clear() {
      this.currentTeamId = null;
      sessionStorage.removeItem(STORAGE_KEY);
    },
  },
});
